import "@mantine/core/styles.css"
import "@civala/shared-ui/styles/pitch-global.css"

import { pitchTheme } from "@civala/shared-ui"
import { MantineProvider } from "@mantine/core"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { App } from "./App"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MantineProvider theme={pitchTheme} defaultColorScheme="light">
      <App />
    </MantineProvider>
  </StrictMode>,
)
